import React, { useEffect, useState } from "react";
import { FaGrinStars } from "react-icons/fa"; // Import smiley icon
import BooleanInputButton from "./BooleanInputButton";
import classNames from "classnames";
import happyFace from '../../../../assets/png/happy-face.png';
import EmojiSelector from "./emojiSelector";

export default function BooleanChoice({ onChangeSmile, ChangeOpitons, options }) {
  const [choiceType, setChoiceType] = useState("text"); 
  const [selectedChoice, setSelectedChoice] = useState(""); 
  const [isAnimating, setIsAnimating] = useState(false); 
  const [isStart, setIsStart] = useState(false);
  // Toggle button handler
  const toggleChoiceType = () => {
    setChoiceType(choiceType === "text" ? "emoji" : "text");
  };

  useEffect(() => {
    setTimeout(() => {
      setIsStart(true);
    }, 500);

    console.log("options",options);
  }, []);

  useEffect(() => {
    if (isStart === true) {
      let value = false;
      if (choiceType === "emoji") {
        value = true;
      }

      if (onChangeSmile) {
        onChangeSmile(value);
      }
    }
  }, [choiceType]);

  // Handle button click and trigger animation
  const handleButtonClick = (choice) => {
    setSelectedChoice(choice);
    setIsAnimating(true);
    // Reset animation after it completes (700ms for slower pulse)
    setTimeout(() => {
      setIsAnimating(false);
    }, 700); // Match this duration with the animation
  };

  return (
    <div className="w-full h-full">
      <div className="p-4 rounded-2xl mt-4 flex flex-col border-2">
        <div className="flex justify-between items-center">
          <div className="relative flex items-center space-x-3">
            <button
              onClick={toggleChoiceType}
              className={`w-12 h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
              ${choiceType === "emoji" ? "bg-red-400 border-2 scale-1050 hover:bg-red-400" : "bg-green-500  scale-1050 hover:bg-green-+00"}`}
            >
                <span className="text-2xl">
                  <img 
                    src={happyFace}
                    alt="happy Emoji" 
                    style={{ width: "auto", height: "2.0rem" }} 
                  />
                </span>
       
            </button>

            <span
              className="text-sm font-medium text-gray-700 transition-all duration-300 ease-in-out opacity-75 hover:opacity-100 cursor-pointer hover:text-green-500 active:text-green-700"
              onClick={toggleChoiceType}
            >
              {choiceType === "emoji"
                ? "Emoji Modundan Çıkmak İçin Tıklayınız"
                : "Emoji Moduna Geçmek İçin Tıklayınız"}
            </span>

          </div>

        </div>

        <div className="border-t-2 border-gray-300 my-4"></div>

        <div
          className={`flex justify-between w-full transition-all duration-500 ease-in-out 
            ${choiceType === "text" ? "opacity-100" : "opacity-0"}`}
        >
          {choiceType === "text" && (
            <>
              <BooleanInputButton ChangeOptions={ChangeOpitons} options={options} />
            </>
          )}
        </div>

        <div
          className={`flex justify-center w-full transition-all duration-500 ease-in-out 
            ${choiceType === "emoji" ? "opacity-100" : "opacity-0"}`}
        >
          {/* Emoji Mode Options */}
          {choiceType === "emoji" && (
            <>
            {/* <div className="flex justify-center space-x-4">
              <button
                className={`w-28 h-28 bg-white rounded-full shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center 
                  hover:bg-yellow-400 transform hover:scale-[1.1] b
                  border-2  ${selectedChoice === "smile" ? "bg-yellow-400 text-white" : "text-yellow-500"} 
                  ${isAnimating ? "animate-pulse duration-700" : ""}`}
                onClick={() => handleButtonClick("smile")}
              >
                <span className="text-7xl">
                  <img 
                    src={happyRobotFace}
                    alt="happy Emoji" 
                    className={`transition-all ${selectedChoice === "smile" ? "animate-bounce" : ""}`} 
                    style={{ width: "auto", height: "4.5rem" }} 
                  />
                </span>

              </button>
              <button
                className={classNames("w-28 h-28 bg-white rounded-full shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center hover:bg-gray-300 transform hover:scale-[1.1] border-2", {
                  "bg-gray-300 text-white": (selectedChoice === "sad"),
                  "text-gray-500": (selectedChoice !== "sad"),
                  "animate-pulse duration-700": isAnimating
                })}
                onClick={() => handleButtonClick("sad")}
              >
                <span className="text-7xl">
                  <img 
                    src={sadRobotFace}
                    alt="Sad Emoji" 
                    className={`transition-all ${selectedChoice === "sad" ? "animate-bounce" : ""}`} 
                    style={{ width: "auto", height: "4.5rem" }} 
                  />
                </span>
              </button>
            </div> */}
            <EmojiSelector isFirst={true} />
            <EmojiSelector isFirst={false} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
